module.exports = __webpack_public_path__ + "static/img/cdi.17b6efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/cdi.jpg
// module id = oCZJ
// module chunks = 0